import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../shared/shared.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-menu-bar',
  templateUrl: './menu-bar.component.html',
  styleUrls: ['./menu-bar.component.css']
})
export class MenuBarComponent implements OnInit {
  hoveringItem = '';
  selectedItem = '';
  versionNo;

  constructor(
    public sharedservice: SharedService,
    private router: Router
  ) { }

  ngOnInit() {
    this.selectedItem = sessionStorage.getItem('commalong_selectedTab');
    this.versionNo = this.sharedservice.versionNo;
  }

  logout() {
    sessionStorage.removeItem('com-session-id');
    this.router.navigate(['/']);
  }

  selectTab(pTab) {
    this.selectedItem = pTab;
    sessionStorage.setItem('commalong_selectedTab', this.selectedItem);
  }
}
